import * as React from 'react'
import { Link, useIntl } from 'gatsby-plugin-react-intl'
import {menuScrollHandler} from 'services/menuScrollHandler'
import { TemperatureUnitPicker } from './TemperatureUnitPicker'
import Logo from 'images/logo_menu.svg'

export const DesktopNav = ({showTemperatureSlider, fadedHeader = true}: {showTemperatureSlider?: boolean, fadedHeader?: boolean}) => {
    const [lastScroll, setLastScroll] = React.useState(0)
    const [isHover, setIsHovered] = React.useState(false)
    const intl = useIntl()



    React.useEffect(() => {
        const handler = () => {
            menuScrollHandler(isHover, lastScroll, setLastScroll);
        }
        document.addEventListener('scroll', handler)

            return () => {
                document.removeEventListener('scroll', handler)
            }

    }, [isHover, lastScroll])

    return (
        <div className={`header ${fadedHeader && 'header--faded'}`} onMouseEnter={()=> setIsHovered(true)}
        onMouseLeave={()=> setIsHovered(false)}
        >
            <div className="row">
                <div className={`col ${showTemperatureSlider? "col--sm--7 col--is--6" : "col--sm--11 col--is--10"}`}>
                    <div className="header__main_nav--holder">
                        <Link to="/" >
                            <span className="header__applogo">
                                <span className="header__applogo--image">
                                    <img src={Logo} alt="Sunheron logo" />
                                </span>
                                <span className="header__applogo--text">
                                    Sunheron
                                </span>
                            </span>
                        </Link>
                        <menu className="header__nav">
                            {/* <li className="header__nav--item">
                                <Link to="/">{intl.formatMessage({ id: 'header.howThingsWork'})}</Link>
                            </li> */}
                            <li className="header__nav--item">
                                <Link to="/about-us/">{intl.formatMessage({id: 'header.aboutSunheron'})}</Link>
                            </li>
                            <li className="header__nav--item">
                                <Link to="/faq/">FAQ</Link>
                            </li>
                            <li className="header__nav--item">
                                <Link to="/contact/">{intl.formatMessage({id: 'header.contact'})}</Link>
                            </li>
                        </menu>
                    </div>
                </div>
                {showTemperatureSlider && <div className="col col--is--4 text--right">
                    {/*<div className="row">
                        <div className="col col--lg--2 col--is--4">
                            <span className="header__search__text">Vyhledat dle teploty</span>
                        </div>
                            <div className="col col--lg--8 col--is--6">
                            <div className="header__search__range center">
                            <FormRangeComponent min={-10} max={36} onChange={()=>{}} id={'header-search'} label={''} isTemperatureSlider/>
                            </div>
                            </div>
                        <div className="col col--lg--2 col--is--1"><button type="button" className="header__search__button"/></div>
                    </div>*/}
                    <input type="text"
                           id="search"
                           className="header__search__field"
                           placeholder="Kam chcete vyrazit?"/>
                    <button type="button" className="header__search__button"/>
                </div>}
                <div className="col col--is--1 text--right">
                    <TemperatureUnitPicker />
                </div>
            </div>
        </div>
    )
}
